import { gql } from 'graphql.macro';

export const MARK_AS_READ = gql`
  mutation markAsRead($notificationIds: [ID!], $readAll: Boolean) {
    markAsRead(notificationIds: $notificationIds, readAll: $readAll)
  }
`;
